var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniqueUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Unique_users"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unique_users",
    clipPath: "url(#clip-Unique_users)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(24 40.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M174.892,42.1a74.489,74.489,0,0,1-100.909,0A104.245,104.245,0,0,0,50.2,58.509,92.61,92.61,0,0,0,18.97,127.552V143.96a21.379,21.379,0,0,0,21.323,21.323H208.66a21.379,21.379,0,0,0,21.323-21.323C233.416,99.95,215.136,62.472,174.892,42.1Z",
    transform: "translate(103.695 247.419)",
    fill: "#6e2b69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M83.608,27.78A58.794,58.794,0,0,0,24.87,86.439c2.766,77.739,114.718,77.715,117.476,0A58.794,58.794,0,0,0,83.608,27.78ZM270.207,58.3A59.959,59.959,0,0,1,196.249,69,55.6,55.6,0,0,1,183.09,58.3a74.449,74.449,0,0,0-24.97,26.079,79.467,79.467,0,0,0-8.323,43.915,17.407,17.407,0,0,0,17.36,17.36H285.981a17.36,17.36,0,0,0,17.36-17.36V116.72A69.772,69.772,0,0,0,270.207,58.3Z",
    transform: "translate(144.564 148.226)",
    fill: "#6e2b69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M371.173,108.5c57.819-1.823,57.811-85.642,0-87.513C313.33,22.813,313.354,106.735,371.173,108.5ZM157.544,175.326V163.753a69.7,69.7,0,0,0-33.214-58.421,59.372,59.372,0,0,1-87.116,0A69.392,69.392,0,0,0,4,163.753v11.573a17.36,17.36,0,0,0,17.36,17.36H140.184a17.408,17.408,0,0,0,17.36-17.36Z",
    transform: "translate(0 101.193)",
    fill: "#6e2b69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M51.571,209.7c57.834-1.776,57.827-85.7,0-87.513C-6.256,124.061-6.232,207.872,51.571,209.7ZM129.254,76.92l26.872,19.342-10.3,31.707a15.5,15.5,0,0,0,5.707,17.518,15.339,15.339,0,0,0,18.39,0l26.714-19.579,27.031,19.579a15.22,15.22,0,0,0,18.39,0,15.5,15.5,0,0,0,5.707-17.518L237.377,96.5,264.328,76.92a15.711,15.711,0,0,0-9.2-28.3L222,48.78q-5.19-15.878-10.3-31.786a15.751,15.751,0,0,0-29.805.079L171.821,48.621H138.449a15.711,15.711,0,0,0-9.2,28.3Z",
    transform: "translate(29.161 0)",
    fill: "#6e2b69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueUsers);
export default __webpack_public_path__ + "static/media/Unique_users.9696b8b9763bb5cfc747f745ce9770cd.svg";
export { ForwardRef as ReactComponent };